import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
  },
  cardBox: {
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgb(145 158 171 / 20%)"
  },
  cardHeader: {
    padding: '20px 20px 10px 20px',

    '@media(max-width: 1100px)': {
      flexDirection: 'column',
    },
    '& .MuiCardHeader-avatar': {
      marginRight: 0,
    },
    '& .MuiCardHeader-content': {
      paddingLeft: 15,
      position: 'relative',
      width: '100%',
      '&:before': {
        content: `" "`,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        width: 4,
        backgroundColor: "#2b398e",
        borderRadius: 4
      }
    },
    '& .MuiCardHeader-action': {
      margin: '0 0 0 20px !important',
      '@media(max-width: 1100px)': {
        marginLeft: 'auto  !important',
        marginTop: '20px !important',
        width: '100%',
      },
      '& .MuiButton-root.MuiButton-outlined': {
        '@media(max-width: 500px)': {
          width: '100%',
        }
      }
    },
  },
  title: {
    paddingTop: theme.spacing(0),
    fontSize: 16,
  },
  subTitle: {
    paddingTop: theme.spacing(1),
    fontSize: 13,
    color: "#9a9a9a",
    textAlign: 'justify',
  },
  helpCard: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(-2),
    backgroundColor: '#eceff1',
    borderRadius: '4px',
    border: 'solid 1px #cfd8dc',
    boxShadow: 'none',
  },
  helpContent: {
    paddingBottom: `${theme.spacing(2)} !important`,
  },
  helpText: {
    fontSize: '13px',
    color: '#003a52',
  },
  breadcrumbs: {
    padding: `0 0 ${theme.spacing(2)} ${theme.spacing(2)}`,
    [theme.breakpoints.down('md')]: {
      '& ol li': {
        marginTop: '4px',
      }
    },
    "& p, & a": {
      fontSize: 12
    }
  },
  breadcrumbsColor: {
    color: '#667585'
  },
  breadcrumbsActivePage: {
    color: "#0C0E10",
    fontWeight: 500
  },
  boxBreadCrumbs: {
    paddingBottom: 10,
    [theme.breakpoints.down('md')]: {
      paddingBottom: 0,
      paddingTop: '8px'
    },
  },
  envUnavailableImg: {
    width: '70%',
    maxWidth: 400,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  envTitle: {
    color: '#1a334d',
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: theme.spacing(2.5),
    '& span': {
      color: theme.palette.primary.main,
    },
  },
  envSubTitle: {
    color: '#1a334d',
    fontSize: 16,
    fontWeight: '300',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    '& a': {
      color: '#006cfc',
      cursor: 'pointer',
    },
  },
  BIBadge: {
    background: theme.palette.grey[200],
    color: theme.palette.grey[600],
    fontSize: 12,
    padding: '3px 9px 4px 4px',
    marginInlineStart: theme.spacing(1),
    display: 'inline-flex',
    borderRadius: 20,
    gap: 4,
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'ease color .25s,ease background .25s',
    position: 'absolute',
    top: '-3px',
    '&:hover': {
      background: theme.palette.primary?.light,
      color: theme.palette.primary?.dark,
    },
    '@media(max-width: 550px)': {
        padding: '3px',
      '& span': {
        display: 'none'
      },
      flexDirection: 'column',
    },
  },
  BIIcon: {
    fontSize: 15,
    marginBottom: theme.spacing(-0.5),
    marginInlineEnd: theme.spacing(1),
  },
  customDisableLayout: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0',
    backgroundColor: 'white',
    opacity: '0.5',
    zIndex: '10000000',
    cursor: 'not-allowed',
  },
  customContent: {
    position: 'relative !important',
  },
}));
